import { render, staticRenderFns } from "./to_do-info.vue?vue&type=template&id=20c04004&scoped=true"
import script from "./to_do-info.vue?vue&type=script&lang=js"
export * from "./to_do-info.vue?vue&type=script&lang=js"
import style0 from "./to_do-info.vue?vue&type=style&index=0&id=20c04004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c04004",
  null
  
)

export default component.exports